import React, {
  memo,
} from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Instruction from '../../components/main/CrossSells/Instruction';
import CrossSellsProductTable from '../../components/main/CrossSells/Table';
import { types as CROSS_SELLS_TYPES, settings as CROSS_SELLS_SETTINGS } from '../../utils/crossSells';

/** @typedef {import('../../redux/reducers').RootState} RootState */

const MINUTES_IN_DAY = 24 * 60;

const CrossSells = () => {
  const {
    crossSellsProductsSelected,
  } = useSelector((/** @type {RootState} */state) => state.UpsellsReducer);

  const WrappedButton = () => {
    if (crossSellsProductsSelected.length === 0) {
      return (
        <button
          className="btn btn-primary create-upsell-btn"
          onClick={() => {}}
          type="button"
          disabled
        >
          Create rule
        </button>
      );
    }

    const triggers = crossSellsProductsSelected.map((product) => ({
      triggerProductId: product.initialProductId,
      triggerVariantId: product.initialProductVariantId,
      name: product.initialProductName,
      variantName: product.initialVariantName,
    }));

    const products = crossSellsProductsSelected.map((product) => ({
      prodToGetProductId: product.followingProductId,
      prodToGetVariantId: product.followingProductVariantId,
      name: product.followingProductName,
      variantName: product.followingVariantName,
    }));

    let avgGapDays = 30;
    if (crossSellsProductsSelected.length > 0) {
      avgGapDays = Math.round(crossSellsProductsSelected[0].avgGapDays);
    }

    return (
      <Link
        to={{
          pathname: '/cross-sells/new',
          state: {
            initialCrossSell: {
              messageContent: CROSS_SELLS_SETTINGS.crossSell.defaultMessage,
              messageInterval: avgGapDays * MINUTES_IN_DAY,
              triggers,
              products,
            },
            type: CROSS_SELLS_TYPES.CROSS_SELLS,
            referrer: '/cross-sells/product-report',
          },
        }}
        className="btn btn-primary create-upsell-btn"
      >
        Create rule
      </Link>
    );
  };

  return (
    <div>
      <Instruction />
      <div className="row">
        <div className="col-md-4">
          <h3>Product cross-sell report</h3>
        </div>
        <div className="col-md-2 offset-md-6">
          <WrappedButton />
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <CrossSellsProductTable />
        </div>
      </div>
    </div>
  );
};

export default memo(CrossSells);
